import React from "react";
import { asset } from "../../utils/assets";
import "./hero.css";

export function Hero() {
  return (
    <section className="hero bg-section hero-video" id="home">
      <div className="hero-bg-video">
        <video autoPlay id="myVideo" loop muted playsInline>
          <source src={asset("hero-bg-video.mp4")} type="video/mp4" />
        </video>
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="hero-content">
              <div className="section-title">
                <img className="hero-logo wow fadeInUp" src={asset("valmetaux-logo.png")} alt="Valmétaux" />
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Achat vente des métaux 
                  Valorisez vos déchets
                </h1>
                <p className="wow fadeInUp" data-wow-delay="0.25s">
                  Achat fer et métaux pose de benne
                  <br />
                  <span className="hero-address">
                    <img src={asset("icon-location.svg")} alt="" />
                    5 rue de l’Ouest, 95100 Argenteuil
                  </span>
                  <span className="hero-phones">
                    <a className="hero-phone" href="tel:+33141400101">
                      <img src={asset("icon-phone.svg")} alt="" />
                      Fixe : +33 1 41 40 01 01
                    </a>
                    <a className="hero-phone" href="tel:+33607561496">
                      <img src={asset("icon-phone.svg")} alt="" />
                      Mobile : +33 6 07 56 14 96
                    </a>
                  </span>
                </p>
              </div>
              <div className="hero-content-body wow fadeInUp" data-wow-delay="0.5s">
                <a className="btn-default" href="#about">
                En savoir plus
                </a>
                <a className="btn-default btn-highlighted" href="#projects">
                Nos prestations
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
